export default __webpack_public_path__ + "static/PACS-09399c05e1271888f9c50b90c1ef9ea2.png";